import '@babel/polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './index.css';
import App from './app';
import AmapApp from '../../components/amap-app';
import InitRun from '../../common/initial';
import { initGdp } from '../../utils/gio-report'

initGdp();

InitRun();

ReactDOM.render(
  <AmapApp plugins={['AMap.Geolocation', 'AMap.MarkerClusterer']}>
    <App />
  </AmapApp>,
  document.getElementById('root')
);
